module.exports = __webpack_public_path__ + "img/index-share-wechat.775d9de9.png";